/**
 * روابط تسجيل الدخول لكل نظام (نفس الخريطة المستخدمة بعد التسجيل في SignUp).
 */
export const LOGIN_URLS: Record<string, string> = {
    gyms: 'https://gym.mrnware.com/login',
    clinics: 'https://clinics.mrnware.com/login',
    educational_centers: 'https://education.mrnware.com/login',
    hotels: 'https://crm.mrnware.com/login',
    real_estate: 'https://crm.mrnware.com/login',
    crm: 'https://crm.mrnware.com/login',
    clinico: 'https://clinico.mrnware.com/login',
    fleet: 'https://fleet.mrnware.com/login',
    hr_management: 'https://hrm.mrnware.com/login',
} as const;

/** Shown inside the CRM portal card (select + login / sign-up). Not listed as separate grid tiles. */
export const CRM_PORTAL_GRID_EXCLUDED = new Set(['crm', 'gyms', 'educational_centers', 'clinics']);

export const LOGIN_OPTIONS: { value: string; labelKey: string; hintKey: string }[] = [
    { value: 'crm', labelKey: 'signUp.productsCrm', hintKey: 'loginPage.crmPortalHintKey' },
    { value: 'fleet', labelKey: 'signUp.fleet', hintKey: 'loginPage.fleetHint' },
    { value: 'hr_management', labelKey: 'signUp.hrManagement', hintKey: 'loginPage.hrManagementHint' },
    { value: 'clinico', labelKey: 'signUp.productsClinico', hintKey: 'loginPage.clinicoHint' },
    { value: 'gyms', labelKey: 'signUp.gyms', hintKey: 'loginPage.gymsHint' },
    // { value: 'clinics', labelKey: 'signUp.clinics', hintKey: 'loginPage.clinicsHint' },
    { value: 'educational_centers', labelKey: 'signUp.educational', hintKey: 'loginPage.educationalHint' },
    { value: 'hotels', labelKey: 'signUp.hotels', hintKey: 'loginPage.hotelsHint' },
    { value: 'real_estate', labelKey: 'signUp.realEstate', hintKey: 'loginPage.realEstateHint' },
];
